import React, { Component, Suspense, lazy } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { connect } from 'react-redux';
import { Route, Switch, withRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import NotFound from './components/Auth/NotFound/NotFound';
import UpdatePassword from './components/Auth/UpdatePassword/UpdatePassword';
import ErrorFallback from './components/ErrorBoundary/FallBack';
import { getModules, setSubModuleToggle } from './ducks/NavHeaderDucks';
import './assets/scss/app.scss';
import './assets/scss/customerDashboard.scss';
import './assets/scss/menu2.scss';
import PrivateRoute from './components/Auth/PrivateRoute/PrivateRoute';
import LoadingAnimation from './components/LoadingAnimation/LoadingAnimation';
import SignIn from './components/Auth/SignIn/SignIn';
import Pusher from 'pusher-js';
import swal from 'sweetalert';
window.Pusher = Pusher;

const LazyDashboard = lazy(() => import('./components/Dashboard/Dashboard'));
const LazyChangePassword = lazy(() => import('./components/Dashboard/ChangePassword'));
const LazyCompanyRegistration = lazy(
  () => import('./components/CompanyRegistration/CompanyRegistration')
);
const LazyRateEnquiryFeedbackForm = lazy(() => import('./components/RateEnquiryFeedbackForm'));
const LazyAboutUs = lazy(() => import('./components/AboutUs/AboutUs'));
const LazyPrivacyPolicy = lazy(() => import('./components/PrivacyPolicy/PrivacyPolicy'));
const LazyMyQuery = lazy(() => import('./components/MyQuery'));
const LazyBookingForm = lazy(() => import('./components/BookingForm/BookingForm'));
const LazyBookingResponse = lazy(() => import('./components/BookingForm/BookingResponse'));
const LazyManualResponseForm = lazy(() => import('./components/RateWizard/ManualResponseForm'));

const LazyCustomerDashboard = lazy(() => import('./components/Dashboard/CustomerDashboard'));
const LazyForgotPassword = lazy(() => import('./components/ForgotPassword/ForgotPassword'));
const LazyAcceptTermsAndConditions = lazy(
  () => import('./components/Dashboard/AcceptTermsAndConditions')
);

const LazyCustomerKycOuterForm = lazy(
  () => import('./components/CustomerKyc/CustomerKycOuterForm')
);
const LazyThankyouPage = lazy(() => import('./components/Auth/NotFound/ThankyouPage'));
const LazySuperAdmin = lazy(() => import('./components/SuperAdminForm/SuperAdmin'));
const LazyInsertAgreementForm = lazy(
  () => import('./components/InsertAgreementForm/InsertAgreementForm')
);

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000 // 5 minutes
    }
  }
});

class App extends Component {
  constructor() {
    super();
    const tk = localStorage.getItem('token');
    if (tk) {
      this.state = {
        isloggedIn: true,
        categoryCode: null,
        showModal: false
      };
      this.timeoutId = null;
    } else {
      this.state = {
        isloggedIn: false,
        categoryCode: null,
        showModal: false
      };
      this.intervalId = null;
    }
    this.intervalId = null;
  }

  componentDidMount() {
    if (this.state.isloggedIn) {
      this.getRole();
      !this.props.modules && this.props.getModules();
      // const ckyc = getCustomerData();
    }
    this.startVersionPolling();
  }

  componentDidUpdate(pP, pS) {
    if (pS.isloggedIn !== this.state.isloggedIn) {
      this.getRole();
      !this.props.modules && this.props.getModules();
    }
  }

  componentWillUnmount() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
  startVersionPolling = () => {
    const CHECK_INTERVAL = 15000;

    this.checkAppVersionMeta();
    this.intervalId = setInterval(this.checkAppVersionMeta, CHECK_INTERVAL);
  };
  checkAppVersionMeta = async () => {
    const currentVersion = localStorage.getItem('currentAppVersion');
    let message = "A new version is available. Click 'OK' to apply the updates.";
    if (this.state.isloggedIn) {
      message = 'A new version is available. You will be logged out to apply updates.';
    }
    try {
      const res = await fetch('/meta.json', { cache: 'no-store' });
      const { version } = await res.json();
      if (!this.state.isloggedIn) {
        localStorage.setItem('currentAppVersion', version);
      } else if (version !== currentVersion) {
        console.log(`App version updated: ${currentVersion} → ${version}`);
        swal({
          title: 'New Version Available',
          text: message,
          icon: 'info',
          closeOnClickOutside: false,
          closeOnEsc: false
        }).then((redirectConfirm) => {
          if (redirectConfirm) {
            localStorage.clear();
            sessionStorage.clear();
            window.location.reload(true);
            window.location.href = '/login';
            localStorage.setItem('currentAppVersion', version);
          }
        });
      }
    } catch (error) {
      console.error('Version check failed:', error);
    }
  };

  checkTAndC = () => {
    const url = this.props.history?.location?.pathname;
    if (
      (localStorage.getItem('isSystemVerified') !== '1' ||
        localStorage.getItem('isEmailVerified') !== '1' ||
        localStorage.getItem('hasAcceptedSystemTAndC') !== 'true') &&
      this.state.categoryCode !== 'CAT_ADM' &&
      url !== '/tandc' &&
      this.state.isloggedIn
    ) {
      this.props.history.push('/tandc');
    }
  };

  getRole = () => {
    const { history } = this.props;
    const customerKyc = JSON.parse(localStorage.getItem('customerKyc'));
    const url = history.location ? history.location?.pathname : '';

    // Check if customerKyc exists
    if (customerKyc) {
      const categoryCode = customerKyc.companyCategory.categoryCode;
      this.setState({ categoryCode }, () => {
        this.checkTAndC();
      });
    }
    // Check for logged in user, missing modulesPermissions and not in super-user-dashboard page
    //temporary fixes as no user needs to go to the super-user-dashboard page on any case other than the superadmin.
    else if (
      this.state.isloggedIn &&
      !localStorage.getItem('modulesPermissions') &&
      localStorage.getItem('loggedInUserId') == 1 &&
      url !== '/super-user-dashboard'
    ) {
      history.push('/super-user-dashboard');
    }
  };

  checkConditions = () => {
    if (
      localStorage.getItem('isSystemVerified') === '1' &&
      localStorage.getItem('isEmailVerified') === '1' &&
      localStorage.getItem('hasAcceptedSystemTAndC') === 'true'
    ) {
      return true;
    } else {
      return false;
    }
  };

  checkFirstLogin = () => {
    return localStorage.getItem('isFirstLogin') === 'true' ? true : false;
  };

  successSetter = () => {
    this.props.setSubModuleToggle(null);
    this.setState({ isloggedIn: true }, () => {
      !this.props.modules && this.props.getModules();
    });
  };

  render() {
    return (
      <QueryClientProvider client={queryClient}>
        <ErrorBoundary FallbackComponent={ErrorFallback}>
          <Suspense fallback={<LoadingAnimation />}>
            <Switch>
              <Route
                path="/"
                exact
                render={() =>
                  this.state.isloggedIn && !this.checkFirstLogin() ? (
                    <>
                      <LazyDashboard modules={this.props.modules} />
                    </>
                  ) : this.checkFirstLogin() ? (
                    <LazyChangePassword />
                  ) : (
                    <SignIn successSetter={this.successSetter} />
                  )
                }
              />

              <PrivateRoute
                authed={this.state.isloggedIn}
                modules={this.props.modules}
                path="/super-user-dashboard"
                component={LazySuperAdmin}
              />
              <PrivateRoute
                authed={this.state.isloggedIn}
                modules={this.props.modules}
                path="/tandc"
                component={LazyAcceptTermsAndConditions}
              />

              <PrivateRoute
                authed={this.state.isloggedIn}
                modules={this.props.modules}
                path="/insert-agreement-form"
                component={LazyInsertAgreementForm}
              />

              <PrivateRoute
                authed={this.state.isloggedIn}
                modules={this.props.modules}
                path="/dashboard"
                component={
                  (this.checkConditions() && localStorage.getItem('isFirstLogin') === 'false') ||
                  this.state.categoryCode === 'CAT_ADM'
                    ? LazyDashboard
                    : !this.checkConditions()
                      ? LazyAcceptTermsAndConditions
                      : LazyChangePassword
                }
              />
              <Route path="/login" render={() => <SignIn successSetter={this.successSetter} />} />
              <Route path="/thankYouPage" component={LazyThankyouPage} />
              <Route
                path="/customerKyc/:user_id?/:email?/:invitation_id?"
                component={LazyCustomerKycOuterForm}
              />
              <Route
                // authed={this.state.isloggedIn}
                path="/update-password/:uname"
                component={UpdatePassword}
              />
              <PrivateRoute
                authed={this.state.isloggedIn}
                path="/change-password"
                component={LazyChangePassword}
              />
              <Route path="/forgotPassword" component={LazyForgotPassword} />
              <Route path="/customerDashboard" component={LazyCustomerDashboard} />
              <Route path="/rateEnquiryResponseForm" component={LazyManualResponseForm} />
              <Route path="/booking-response/:refNo" component={LazyBookingResponse} />
              <Route path="/booking-form" component={LazyBookingForm} />
              <Route path="/myQuery" component={LazyMyQuery} />
              <Route path="/privacy-policy" component={LazyPrivacyPolicy} />
              <Route path="/aboutus" component={LazyAboutUs} />
              <Route path="/feedback-form" component={LazyRateEnquiryFeedbackForm} />
              <Route path="/registrationForm" component={LazyCompanyRegistration} />
              <Route path="*" render={() => <NotFound />} />
            </Switch>
          </Suspense>
        </ErrorBoundary>
      </QueryClientProvider>
    );
  }
}

const mapStateToProps = (state, props) => ({
  modules: state.modules.modules
});

const mapActionToProps = {
  getModules,
  setSubModuleToggle
};

export default connect(mapStateToProps, mapActionToProps)(withRouter(App));
